import type { ContentBlock } from "../../blockTypes";

import HeadingBlock from "./HeadingBlock";
import ImageBlock from "./ImageBlock";
import ListBlock from "./ListBlock";
import MultipleChoiceBlock from "./MultipleChoiceBlock";
import PlaceholderCodeBlock from "./PlaceholderCodeBlock";
import ProgramCodeBlock from "./ProgramCodeBlock";
import SingleChoiceBlock from "./SingleChoiceBlock";
import TextBlock from "./TextBlock";

interface BlockRendererProps {
    block: ContentBlock;
    onComplete?: () => void; // A question was answered correctly
    onAnswer?: (isCorrect: boolean) => void; // Every answer, right or wrong
}

// Picks the components for a block. Inside each case TypeScript knows the exact config type.
const BlockRenderer = ({ block, onComplete, onAnswer }: BlockRendererProps) => {
    switch (block.type) {
        case "text":
            return <TextBlock config={block.config} />;

        case "heading":
            return <HeadingBlock config={block.config} />;

        case "image":
            return <ImageBlock config={block.config} />;

        case "list":
            return <ListBlock config={block.config} />;

        case "code":
            return <ProgramCodeBlock config={block.config} />;

        case "question_single_choice":
            return <SingleChoiceBlock config={block.config} onComplete={onComplete} onAnswer={onAnswer} />;
        case "question_multiple_choice":
            return <MultipleChoiceBlock config={block.config} onComplete={onComplete} onAnswer={onAnswer} />;
        case "placeholder_code":
            return <PlaceholderCodeBlock config={block.config} onComplete={onComplete} onAnswer={onAnswer} />;

        default:
            // New block types from the server show up here instead of crashing the lesson
            console.warn(`Unknown lesson block type: ${(block as { type: string }).type}`);
            return null;
    }
};

export default BlockRenderer;